var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 8,
    fill: "#FFEEF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5807 9.69531H13V33.0775H29.5807V9.69531Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.70059L14.7006 8",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5834 9.70059L27.8828 8",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8788 8H14.6992",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2773 33.0859V34.3622",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2773 34.3594H18.5288",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5273 34.3622V33.0859",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0547 33.0859V34.3622",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0547 34.3594H28.3062",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3047 34.3622V33.0859",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3033 28.8281H14.2734V31.8042H28.3033V28.8281Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3033 10.9766H14.2734V27.5573H28.3033V10.9766Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2734 16.5078H28.3033",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2734 22.0234H28.3033",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5268 15.652C18.5268 16.1197 18.1442 16.5023 17.6765 16.5023H16.4011C15.9334 16.5023 15.5508 16.1197 15.5508 15.652V13.1003C15.5508 12.6322 15.9334 12.25 16.4011 12.25H17.6765C18.1442 12.25 18.5268 12.6322 18.5268 13.1003V15.652Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 13.5312H18.5268",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 15.2266H18.5268",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7807 21.1833C22.7807 21.6514 22.3981 22.034 21.9304 22.034H20.655C20.1873 22.034 19.8047 21.6514 19.8047 21.1833V18.6315C19.8047 18.1639 20.1873 17.7812 20.655 17.7812H21.9304C22.3981 17.7812 22.7807 18.1639 22.7807 18.6315V21.1833Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8047 19.0547H22.7807",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8047 20.7578H22.7807",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0307 15.652C27.0307 16.1197 26.6481 16.5023 26.1804 16.5023H24.905C24.4373 16.5023 24.0547 16.1197 24.0547 15.652V13.1003C24.0547 12.6322 24.4373 12.25 24.905 12.25H26.1804C26.6481 12.25 27.0307 12.6322 27.0307 13.1003V15.652Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0547 13.5312H27.0307",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0547 15.2266H27.0307",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5268 26.7145C18.5268 27.1826 18.1442 27.5648 17.6765 27.5648H16.4011C15.9334 27.5648 15.5508 27.1826 15.5508 26.7145V24.1628C15.5508 23.6951 15.9334 23.3125 16.4011 23.3125H17.6765C18.1442 23.3125 18.5268 23.6951 18.5268 24.1628V26.7145Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 24.5781H18.5268",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 26.2891H18.5268",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0307 26.7145C27.0307 27.1826 26.6481 27.5648 26.1804 27.5648H24.905C24.4373 27.5648 24.0547 27.1826 24.0547 26.7145V24.1628C24.0547 23.6951 24.4373 23.3125 24.905 23.3125H26.1804C26.6481 23.3125 27.0307 23.6951 27.0307 24.1628V26.7145Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0547 24.5781H27.0307",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0547 26.2891H27.0307",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9766 22.0316V19.9062",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9766 19.8972L16.4017 19.0469",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1016 22.0316V19.9062",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1009 19.8972L17.6758 19.0469",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6739 17.7812H16.3984V19.0571H17.6739V17.7812Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2266 16.5007V14.375",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2266 14.3659L20.6517 13.5156",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3516 16.5007V14.375",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3509 14.3659L21.9258 13.5156",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9278 12.2422H20.6523V13.5176H21.9278V12.2422Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4766 22.0316V19.9062",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4766 19.8972L24.9017 19.0469",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6016 22.0316V19.9062",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6048 19.8972L26.1797 19.0469",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1817 17.7812H24.9062V19.0571H26.1817V17.7812Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9317 23.3125H20.6562V27.5635H21.9317V23.3125Z",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6562 24.5781H21.9317",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6562 26.2891H21.9317",
    stroke: "#F79FC2",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVm);
export default __webpack_public_path__ + "static/media/vm.f701651d594436586eab4860b165d955.svg";
export { ForwardRef as ReactComponent };